var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSunny01 = function SvgSunny01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sunny-01_svg2__a",
    x1: 33.94,
    x2: 170.05,
    y1: 166.06,
    y2: 29.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sunny-01_svg2__a",
    id: "sunny-01_svg2__b",
    x1: 33.94,
    x2: 170.05,
    y1: 166.06,
    y2: 29.95
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sunny-01_svg2__a",
    id: "sunny-01_svg2__c",
    x1: 9.58,
    x2: 145.68,
    y1: 141.69,
    y2: 5.59
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M100 153.38c29.48 0 53.38-23.9 53.38-53.38S129.48 46.62 100 46.62 46.62 70.52 46.62 100s23.9 53.38 53.38 53.38m0 9.7c34.84 0 63.08-28.24 63.08-63.08S134.84 36.92 100 36.92 36.92 65.16 36.92 100s28.24 63.08 63.08 63.08",
    style: {
      fillRule: "evenodd",
      fill: "url(#sunny-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.25 2.73c3.76-3.64 9.73-3.64 13.5 0l18.91 18.3 26.06-3.69c5.18-.73 10.01 2.78 10.92 7.93l4.55 25.92 23.24 12.33c4.62 2.45 6.47 8.13 4.17 12.83l-11.56 23.64 11.56 23.64c2.3 4.7.45 10.38-4.17 12.84l-23.24 12.33-4.55 25.92a9.69 9.69 0 0 1-10.92 7.93l-26.06-3.69-18.91 18.3c-3.76 3.64-9.73 3.64-13.5 0l-18.91-18.3-26.06 3.69c-5.18.73-10.01-2.78-10.92-7.93l-4.55-25.92-23.24-12.33c-4.62-2.45-6.47-8.13-4.17-12.84l11.56-23.64L5.4 76.35c-2.3-4.7-.45-10.38 4.17-12.83l23.24-12.33 4.55-25.92c.9-5.16 5.73-8.66 10.92-7.93l26.06 3.69zM118.91 28 100 9.7 81.09 28a9.7 9.7 0 0 1-8.11 2.63l-26.06-3.69-4.55 25.92a9.74 9.74 0 0 1-5.01 6.9L14.11 72.09l11.56 23.64a9.73 9.73 0 0 1 0 8.52l-11.56 23.64 23.25 12.33a9.72 9.72 0 0 1 5.01 6.9l4.55 25.92 26.06-3.69c2.96-.42 5.96.55 8.11 2.63l18.91 18.3 18.91-18.3a9.7 9.7 0 0 1 8.11-2.63l26.06 3.69 4.54-25.92a9.74 9.74 0 0 1 5.01-6.9l23.24-12.33-11.56-23.64a9.73 9.73 0 0 1 0-8.52l11.56-23.64-23.24-12.33a9.72 9.72 0 0 1-5.01-6.9l-4.54-25.92-26.06 3.69c-2.96.42-5.96-.55-8.11-2.63",
    style: {
      fillRule: "evenodd",
      fill: "url(#sunny-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.41 63.12a4.85 4.85 0 0 1-.97 6.79l-2.17 1.63a43.64 43.64 0 0 0-15.39 21.63l-1.07 3.35a4.852 4.852 0 0 1-9.24-2.96l1.07-3.34a53.37 53.37 0 0 1 18.81-26.43l2.17-1.63a4.85 4.85 0 0 1 6.79.97",
    style: {
      fill: "url(#sunny-01_svg2__c)",
      fillRule: "evenodd"
    }
  }));
};
export default SvgSunny01;